import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'

import { STATUS_NOT_OK, HTTP_CODE_VERIFY_UNAUTHORIZED } from 'src/effects/VerifyEmail/constants'

import { fetchVerifyEmailRequestAction } from 'src/effects/VerifyEmail/actions'
import { getErrorCode, getIsFetching } from 'src/effects/VerifyEmail/selectors'
import { validateEmail } from 'client/helpers/Form'

import ButtonSimple from 'src/comps/ButtonSimple'
import Feedback from 'client/components/FeedbackVoucher'
import FormErrorMessage from 'client/components/FormErrorMessage'
import IconEmail from 'client/icons/Email'
import InputLine from 'client/components/InputLine'

import {
  ButtonContainer,
  InputSection,
  SubTitle,
  Title,
  VerifyEmailBase,
  WrapperInput,
} from './styles'
import messages from './messages'

const VerifyEmail = ({ hash, onSuccess, buttonText }) => {
  const intl = useIntl()
  const dispatch = useDispatch()

  const [email, setEmail] = useState('')
  const [errors, setErrors] = useState({ email: false })

  const statusCode = useSelector(getErrorCode(hash))
  const isLoading = useSelector(getIsFetching(hash))

  function validForm() {
    const error = {
      email: validateEmail(email, { required: true }),
    }

    setErrors(error)
    return !error.email
  }

  function handleSubmitForm(event) {
    event.preventDefault()
    event.stopPropagation()

    if (!validForm()) {
      return
    }

    dispatch(fetchVerifyEmailRequestAction({ email, hash }))

    if (onSuccess) {
      onSuccess()
    }
  }

  return (
    <VerifyEmailBase>
      <Title>
        <FormattedMessage {...messages.introduceEmail} />
      </Title>

      <SubTitle>
        <FormattedMessage {...messages.forYourSafety} />
      </SubTitle>

      <WrapperInput>
        <InputSection>
          <InputLine
            label={intl.formatMessage(messages.email)}
            name="email"
            onChange={event => setEmail(event.target.value)}
            type="email"
            value={email}
            role="textbox"
            icon={<IconEmail />}
          />
        </InputSection>
        {errors.email && <FormErrorMessage errors={errors.email} />}
      </WrapperInput>

      <ButtonContainer>
        <ButtonSimple
          dataTestId="email-verification-submit"
          onClick={event => handleSubmitForm(event)}
          type="submit"
          isLoading={isLoading}
          text={buttonText}
          variant="primary"
          fullWidth
        />
      </ButtonContainer>

      {statusCode === HTTP_CODE_VERIFY_UNAUTHORIZED && (
        <Feedback
          dataTestId="status-unauthorized"
          text={[intl.formatMessage(messages.verifyEmailUnathorized)]}
          status={STATUS_NOT_OK}
        />
      )}
    </VerifyEmailBase>
  )
}

VerifyEmail.propTypes = {
  hash: PropTypes.string,
  onSuccess: PropTypes.func,
  buttonText: PropTypes.string,
}

export default VerifyEmail
